import "./CustomInput.css";
import React from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import FormField from "../../mixins/FormField";
import autobind from "autobind-decorator";
import isUndefined from "lodash/isUndefined";

class CustomInput extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        label: PropTypes.node,
        type: PropTypes.oneOf(["text", "number", "email", "tel", "date", "datetime", "month", "search", "password"]),
        multiline: PropTypes.bool,
        onKeyDown: PropTypes.func,
        onPaste: PropTypes.func
    };

    static defaultProps = {
        type: "text",
        multiline: false
    };

    @autobind
    handleEnter(e) {
        if (this.props.onKeyDown) {
            this.props.onKeyDown(e);
            if (e.defaultPrevented) {
                return;
            }
        }

        if (e.key === "Enter") {
            this.value = this.inputElement.value;
            this.updateBackingValue(true);

            if (!isUndefined(this.props.onBlur)) {
                this.props.onBlur(e);
            } else {
                this.inputElement.select();
            }
        }
    }

    @autobind
    onChange() {
        this.dirty = true;
        this.handleChange();
    }

    @autobind
    onBlur(e) {
        // Warning: The JavaScript blur action (not our function here, but JavaScript's
        // built-in blur) does not behave the same way on mobile as it does on desktop.
        this.handleBlur(e);
        // Used if you want to trigger an action on blur ONLY if there are changes to the underlying model.
        if (this.dirty && this.props.handleBlurPostAction) {
            this.props.handleBlurPostAction();
            this.dirty = false;
        }
    }

    render() {
        const {
            fieldName,
            label,
            type,
            id,
            name,
            inputDisabled,
            skipBlur,
            autoComplete,
            multiline,
            onPaste
        } = this.props;

        const blur = skipBlur ? () => {
            return;
        } : this.onBlur;

        const commonProps = {
            id: id || fieldName,
            name: name || fieldName,
            ref: this.setInputRef,
            value: this.readValue(),
            onChange: this.onChange,
            onBlur: blur,
            onFocus: this.handleFocus,
            ...this.getInnerInputProps(),
            disabled: inputDisabled,
            autoComplete: type === "password" ? "off" : autoComplete,
            onPaste: onPaste
        };

        return (
            <div className={this.getClassNames("custom-input")}>
                {!isEmpty(label) &&
                    <label htmlFor={fieldName}>{label}</label>
                }
                {multiline ?
                    (<textarea
                        {...commonProps}
                        onKeyDown={this.handleEnter}
                    />) :
                    (<input
                        type={type}
                        {...commonProps}
                        onKeyDown={this.handleEnter}
                    />)}
                {this.renderErrors()}
            </div>
        );
    }
}

// FormField makes this an observer
export default FormField(CustomInput);
